export const sharedEnvironmentLocal = {
  production: false,
  name: 'Local',
  bgcolor: 'silver',
  fontcolor: 'black',
  showEnvironment: true,
  cookieDomain: '.vinnova.se',
  tinyMceApiKey: '3v8orrp96m8v7vwbg61c31rrhu3dffg5wi6rlluihkl56ot0',
  ga4MeasurementId: 'G-DJPY2PMYE7',
};
